export default __webpack_public_path__ + "static/media/MDX-BNB.92155eec.png";